module.exports = __webpack_public_path__ + "img/bus-station-end.d1a27fe5.svg";